import { render } from "./JoinAssociation.vue?vue&type=template&id=e2637588"
import script from "./JoinAssociation.vue?vue&type=script&lang=js"
export * from "./JoinAssociation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__